import css from 'styled-jsx/css'
const styles = css`
  .btn {
    position: relative;
    color: #fff;
    padding-bottom: 4px;
  }
  .btn-fl-md {
    height: 50px;
    padding: 0 30px;
    vertical-align: middle;
  }
  .btn-fl-submit {
    border-bottom: 2px solid #bf6224;
  }
  .btn-fl-submit:hover {
    background-color: #bf6224;
  }
  .arrow-right-white:after {
    content: '';
    width: 7px;
    height: 7px;
    border: 0px;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: calc(50% - 3px);
    right: 10px;
  }
  .btn-fl-cancel {
    background-color: #92949b;
    border-bottom: 2px solid #5e616e;
  }
  .btn-fl-cancel:hover {
    background-color: #5e616e;
  }
  .arrow-left-white:before {
    content: '';
    width: 7px;
    height: 7px;
    border: 0px;
    border-top: 2px solid #fff;
    border-left: 2px solid #fff;
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    position: absolute;
    top: calc(50% - 3px);
    left: 10px;
  }
`
interface Props {
  text: string
  showArrow?: boolean
  bgColor?: string
  bbColor?: string
  className?: string
  isSubmit?: boolean
  disabled?: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const SubmitButton: React.FC<Props> = ({
  text,
  showArrow = false,
  bgColor = '#fd8637',
  bbColor = '#bf6224',
  className = '',
  isSubmit = true,
  disabled = false,
  onClick,
}) => {
  const direction = isSubmit ? 'right' : 'left' // 矢印の向き
  return (
    <button
      className={[
        'btn btn-fl-md disabled:opacity-50',
        isSubmit ? 'btn-fl-submit' : 'btn-fl-cancel',
        showArrow && `arrow-${direction}-white`,
        className,
      ].join(' ')}
      onClick={onClick}
      disabled={disabled}
    >
      <span>{text}</span>
      <style jsx>{styles}</style>
      <style jsx>{`
        .btn-fl-submit {
          background-color: ${bgColor};
          border-bottom: 2px solid ${bbColor};
        }
        .btn-fl-submit:hover {
          background-color: ${bbColor};
        }
      `}</style>
    </button>
  )
}
